import { jsx as _jsx } from "react/jsx-runtime";
import { createElement, forwardRef } from "react";
export const WebComponent = forwardRef(({ tagName, ...restProps }, ref) => {
    // Pass the ref directly to the WebComponent
    const webComponentElement = createElement(tagName, { ...restProps, ref });
    return _jsx("div", { className: "custom-web-component-wrapper", children: webComponentElement });
});
//# sourceMappingURL=WebComponent.js.map